export default "__VITE_ASSET__ibZSc8s2__"